export default "__VITE_ASSET__CNFEKW9h__"